// angular
//     .module("HeroPRO")
//     .factory("ConfirmLeaveFactory", ConfirmLeaveFactory);

/* @ngInject */
export default function ConfirmLeaveFactory($uibModal) {
    return ($event, loc, cancelLocationChange) => {
        $uibModal.open({
            templateUrl: 'app/modals/confirmLeave/confirmLeave.html',
            controller: 'ConfirmLeaveController',
            controllerAs: 'confirmLeave',
            backdrop: 'static',
            keyboard: false,
            animation: false,
            resolve: {
                _$event() { return $event; },
                cancelLocationChange() { return cancelLocationChange; },
            },
        });
    };
}



// WEBPACK FOOTER //
// ./src/app/modals/confirmLeave/ConfirmLeaveFactory.js